import { ActivityReasonCategory } from '../../types/activity'

export const SOURCE = 'enrollme-web-client'

export const ACTIVITY_LOG_SOURCE = 'admin-web-client'

export const ActivityLogAction = {
  ADD_DEPENDENT: 'Add Dependent',
  EDIT_DEPENDENT: 'Edit Dependent',
  DELETE_DEPENDENT: 'Delete Dependent',
  SAVE_AND_CONTINUE_DEPENDENTS: 'Save & Continue Dependents',
  EDIT_PERSONAL_INFO: 'Edit Personal Info',
  ADD_PROVIDER: 'Add Provider',
  REMOVE_PROVIDER: 'Remove Provider',
  REMOVE_ALL_FROM_PROVIDER: 'Remove All From Provider',
  TOGGLE_SMS_OPT_IN: 'Toggle SMS Opt-In',
  VIEW_SMS_TERMS: 'View SMS Terms and Conditions',
  VIEW_SMS_PRIVACY_POLICY: 'View SMS Privacy Policy',
}

export const ReasonCategories = [
  { value: ActivityReasonCategory.QLE, label: 'QLE' },
  { value: ActivityReasonCategory.ER_REQUEST, label: 'ER request' },
  { value: ActivityReasonCategory.EE_REQUEST, label: 'EE request' },
  { value: ActivityReasonCategory.CLEANUP, label: 'Cleanup' },
  { value: ActivityReasonCategory.OTHER, label: 'Other' },
]
